document.addEventListener('ajaxProduct:added', function (e) {
  setTimeout(function() {
    runShipscoutSnippet();
  }, 1000);
});

document.addEventListener('drawerOpen', function (e) {
  setTimeout(function() {
    runShipscoutSnippet();
  }, 1000);
});

document.addEventListener('cart:updated', function (e) {
  setTimeout(function() {
    runShipscoutSnippet();
  }, 1000);
});

function runShipscoutSnippet() {
  window._shipScout = window._shipScout || [];
  _shipScout.push(function (response) {
    /*
      example response object
      {
        testId: 1,
        testType: 'threshold',
        variant: 'B',
        threshold: true,
        freeShippingThresholdCents: 5000,
        shippingPriceCents: 1000,
        lineItemProperty: 0467e6f7-8d66-4610-a939-da76dd9f7a68_1_B
      }
    */

      // response = {
      // 	...response,
      // 	freeShippingThresholdCents: 35000
      // }

    //apply any exchange rates to currency if necessary
    var thresholdCents = (window.Shopify && Shopify.currency && Shopify.currency.rate) ? response.freeShippingThresholdCents * Shopify.currency.rate : response.freeShippingThresholdCents;
    var flatrateCents = (window.Shopify && Shopify.currency && Shopify.currency.rate) ? response.shippingPriceCents * Shopify.currency.rate : response.shippingPriceCents;

    //format currency
    var currencyFormat 							= ShipScoutGetCurrency();

    //get threshold amount with currency symbol
    var thresholdAmount 						= ShipScoutFormatMoney(thresholdCents, currencyFormat);

    //get flat rate amount with currency symbol
    var flatrateAmount 							= ShipScoutFormatMoney(flatrateCents, currencyFormat);

    //==== insert your code below to dynamically update elements ====//

    //example updating an element on the page dynamically with the threshold amount
      var element 										= document.querySelector('[data-subtotal-number]');
      const subtotalText          		= element.innerHTML;
      const updatedPrice          		= parseFloat(subtotalText.replace('$', ''));
      const countdownsContainer   		= document.getElementById("volt-bonus_countdowns_data");
      const countdowns_data       		= JSON.parse(countdownsContainer.textContent);

      const amount                		= response.freeShippingThresholdCents/100
      const message               		= countdowns_data.thresholds[0].message;
      const subtotal              		= countdowns_data.subtotal;
      const percent_bar           		= countdowns_data.percent_bar;
      const complete_message      		= countdowns_data.complete_message;

      // Recalculate values
      const money_to_discount_number  = amount - updatedPrice;
      let percent_number              = ((updatedPrice/amount)*100).toFixed(0);

      if (percent_number > 100) {
        percent_number = 100
      };

      const money_to_discount_text    = '$' + (money_to_discount_number)
      const percent_text              = percent_number + '%'
      let updated_message             = message.replace('[n]', money_to_discount_text)

      if (money_to_discount_number <= 0) {
        updated_message = complete_message
      };

      if (response.freeShippingThresholdCents != undefined) {
        document.querySelector('.counter_percent').style.width = percent_text;
        document.querySelector('.counter_percent').innerText = percent_text;
        document.querySelector('.bonus_countdown p').innerText = updated_message;

      if (elCountdown != null) {
        if(response.freeShippingThresholdCents === 0) {
          elCountdownParagraph.innerHTML = completeMessage;
        } else {
          elCountdownParagraph.innerHTML = newMessage;
        }
      };
      };
  });
}

